/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, List, ListItemButton, Theme as MaterialTheme, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme, } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';

import { useTranslation } from 'react-i18next';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import { IDepartmentGuiModel } from '../../../model/IDepartmentGuiModel';
import DepartmentBusinessLogic from '../../../businessLogic/DepartmentBusinessLogic';

interface IDialogProps {
    organizationId: string | undefined,
    dialogOpen: boolean,
    handleDialogClose: () => void,
    setDepartment: Dispatch<SetStateAction<string>>,
    handleNewDepartment: (newDepartment: IDepartmentGuiModel) => void,
}


const DialogVatCodeSearch = (props: IDialogProps): JSX.Element => {

    const { organizationId, dialogOpen, handleDialogClose, setDepartment, handleNewDepartment } = props;

    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [loader, setLoader] = useState(false);

    const [departmentList, setDepartmentList] = useState<IDepartmentGuiModel[]>([]);
    const [departmentListError, setDepartmentListError] = useState<string[]>([]);

    const handleRowClick = (listIndex: number) => {
        setDepartment(departmentList[listIndex].departmentId);
        handleNewDepartment(departmentList[listIndex])
        handleInnerDialogClose();
    }

    const handleInnerDialogClose = () => {
        handleDialogClose();
    }

    useEffect(() => {

        let isMounted = true; //Avoid memory leaks. Async function running after dismount.

        const getAccounts = async () => {

            let logic = new DepartmentBusinessLogic();
            setLoader(true);
            const result = await logic.getDepartments(organizationId ? organizationId : "");
            setLoader(false);
            if (result.hasErrors) {
                if (isMounted) setDepartmentListError(result.errors);
            } else {
                if (isMounted) setDepartmentListError([]);
                if (isMounted) {
                    setDepartmentList(result.value);
                }
            }
        }

        getAccounts();

        return () => { isMounted = false };

    }, [organizationId])

    return <Dialog
        open={dialogOpen}
        onClose={handleInnerDialogClose}>
        <DialogTitle display="flex" justifyContent="flex-end">
            <IconButton onClick={handleDialogClose}><Close /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
            {departmentListError.length > 0 ? <Typography>{t("basic.errorWithAccounts") + departmentListError.join(", ")}</Typography> :
                <Box component={Paper} sx={{ border: 1, borderColor: 'divider' }}>
                    {loader ? <CircularProgress color="inherit" /> : <>
                        <TableContainer sx={{ maxHeight: "15rem" }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t("basic.vatId")}</TableCell>
                                        <TableCell>{t("basic.name")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody component={List}>
                                    {departmentList.map((e, index) =>
                                        <TableRow component={ListItemButton} onClick={() => handleRowClick(index)}>
                                            <TableCell>
                                                {e.departmentId}
                                            </TableCell>
                                            <TableCell>
                                                {e.name}
                                            </TableCell>
                                        </TableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>}
                </Box>}
        </DialogContent>
    </Dialog>
}

export default DialogVatCodeSearch;